
import { Component, EventEmitter, Input, Output} from '@angular/core';
// ------------------------------------------------------------------------------------------
@Component({
  selector: 'lib-button-1',
  templateUrl: './button-1.component.html',
  styleUrls: ['./button-1.component.css']
})
export class Button1Component {
  @Input() buttonText = 'Text';
  @Output() buttonPressed = new EventEmitter<void>();
  // ------------------------------------------------------------------------------------------
  onClick() {
    this.buttonPressed.emit();
  }
}

